/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TesterType
{
    EXTERNAL_TESTER = 'ExternalTester',
    MC_TESTER = 'McTester',
    FF_TESTER = 'FfTester'
}


